import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=4377392a&"
import script from "./DueDate.vue?vue&type=script&lang=js&"
export * from "./DueDate.vue?vue&type=script&lang=js&"
import style0 from "./DueDate.vue?vue&type=style&index=0&lang=scss&coped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports